import { render, staticRenderFns } from "./CreateDiscountForm.vue?vue&type=template&id=79e4b6ef"
import script from "./CreateDiscountForm.vue?vue&type=script&lang=js"
export * from "./CreateDiscountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports